import React from "react";

import { useLocation } from "@reach/router";
import CategoryBreadcrumb from "../../../AC-Breadcrumb/CategoryBreadcrumb.jsx";

export default function CategoryHeader({ data, dynamic }) {
  const location = useLocation();
  console.info("borop data", data);

  return (
    <React.Fragment>
      <div className="container">
        <div style={{ paddingTop: "15px" }}>
          <div className="category-content">
            <div className="mobile-spacer"></div>

            {/* 
        <div className="sub-nav-menu" style={{backgroundColor:"red"}}> 
          <div className="sub-nav-title-desc-wrapper">
            <Grid container justify="space-between" alignItems="center">
              <Grid item xs={12}>
                <h2
                  style={{ backgroundColor: "transparent" }}
                  className="sub-nav-menu-title"
                  dangerouslySetInnerHTML={{
                    __html: htmlDecode(data.description)
                  }}
                ></h2>
              </Grid>
            </Grid>
          </div>
        </div> */}

            <div className="print-header" style={{ width: "100%" }}>
              <div className="right-align" style={{ textAlign: "right" }}>
                <h2
                  dangerouslySetInnerHTML={{
                    __html: dynamic ? "Search" : data.description
                  }}
                ></h2>{" "}
              </div>
              <h1 style={{ margin: "0px" }}>Print Online</h1>
              {/* TO FIX Full breadcrumb not working */}
              <div>
                <CategoryBreadcrumb />{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
